import MultiCommView from "./MultiCommView";
export default MultiCommView